const initDownloadBrochureModal = () => {
    const downloadBrochureModal = document.getElementById("download-brochure-popup");
    const downloadBrochureCloseButton = document.getElementById("download-brochure-close-button");
    if (downloadBrochureCloseButton && downloadBrochureModal) {
        downloadBrochureCloseButton.onclick = function () {
            downloadBrochureModal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target === downloadBrochureModal) {
                downloadBrochureModal.style.display = "none";
            }
        };
        document.getElementById("download-brochure").addEventListener("click", function (event) {
            event.preventDefault();
            downloadBrochureModal.style.display = "block";
        });
        window.addEventListener("message", function (event) {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                downloadBrochureModal.style.display = "none";
                const downloadBrochureLink = document.getElementById("download-brochure");
                if (downloadBrochureLink != undefined) {
                    const downloadBrochureLinkAddress = downloadBrochureLink["href"];
                    if (downloadBrochureLinkAddress != undefined) {
                        window.open(downloadBrochureLinkAddress, '_blank').focus();
                    }
                }
            }
        });
    }
};
